"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberWithCurrencyWithFallback = exports.numberWithCurrency = exports.numberWithLessDecimals = exports.numberWithTwoDecimals = void 0;
const lodash_1 = require("lodash");
const numberWithTwoDecimals = (value) => (0, lodash_1.toNumber)(value).toFixed(2);
exports.numberWithTwoDecimals = numberWithTwoDecimals;
const numberWithLessDecimals = (value) => Number.parseFloat((0, exports.numberWithTwoDecimals)(value)).toString();
exports.numberWithLessDecimals = numberWithLessDecimals;
const numberWithCurrency = ({ currency, options = {}, value, }) => {
    var _a, _b, _c;
    const { currencyDisplay, locale = (_b = (_a = window === null || window === void 0 ? void 0 : window.I18n) === null || _a === void 0 ? void 0 : _a.locale) !== null && _b !== void 0 ? _b : 'en-US' } = options;
    const currencyCode = (_c = currency === null || currency === void 0 ? void 0 : currency.code) !== null && _c !== void 0 ? _c : currency;
    try {
        const numeralValue = Number(value);
        const formatOptions = Object.assign({ maximumFractionDigits: Number.isInteger(numeralValue) ? 0 : undefined }, options);
        if (currencyCode) {
            (0, lodash_1.merge)(formatOptions, {
                currency: currencyCode,
                currencyDisplay: currencyDisplay || 'code',
                style: 'currency',
            });
        }
        return new Intl.NumberFormat(locale, formatOptions)
            .format(numeralValue)
            .replace(/\u00A0/gu, ' ');
    }
    catch (_d) {
        return `${value} ${currency}`;
    }
};
exports.numberWithCurrency = numberWithCurrency;
const numberWithCurrencyWithFallback = ({ currency, locale, value, }) => {
    var _a;
    if (!value || value === '0.0') {
        return '-';
    }
    return (0, exports.numberWithCurrency)({
        currency,
        options: {
            currencyDisplay: 'narrowSymbol',
            locale: locale || ((_a = window === null || window === void 0 ? void 0 : window.I18n) === null || _a === void 0 ? void 0 : _a.locale),
        },
        value,
    });
};
exports.numberWithCurrencyWithFallback = numberWithCurrencyWithFallback;
//# sourceMappingURL=index.js.map